import request from '@/utils/request'

let SettingApi = {

  /*商城设置模板变量*/
  storeDetail(data) {
    return request._get('/shop/setting.store/index', data);
  },
  /*保存商城设置*/
  editStore(data) {
    return request._post('/shop/setting.store/index', data);
  },
  /*交易设置模板变量*/
  tradeDetail(data) {
    return request._get('/shop/setting.trade/index', data);
  },
  /*保存交易设置*/
  editTrade(data) {
    return request._post('/shop/setting.trade/index', data);
  },
  /*短信通知模板变量*/
  smsDetail(data) {
    return request._get('/shop/setting.sms/index', data);
  },
  /*保存短信通知*/
  editSms(data) {
    return request._post('/shop/setting.sms/index', data);
  },
  /*发送短信*/
  sendSms(data) {
    return request._post('/shop/setting.sms/smsTest', data);
  },
  saveCommissionSettings(data) {
    return request._post('/shop/setting.commission/index', data);
  },
  getCommissionSettings(data) {
    return request._post('/shop/setting.commission/getCommissionSettings', data);
  },
  /*上传设置模板变量*/
  storageDetail(data) {
    return request._get('/shop/setting.storage/index', data);
  },
  /*保存上传设置*/
  editStorage(data) {
    return request._post('/shop/setting.storage/index', data);
  },
  /*打印设置模板变量*/
  printingDetail(data) {
    return request._get('/shop/setting.printing/index', data);
  },
  /*保存打印设置*/
  editPrinting(data) {
    return request._post('/shop/setting.printing/index', data);
  },
  /*打印设置模板变量*/
  clearDetail(data) {
    return request._get('/shop/setting.clear/index', data);
  },
  /*保存缓存*/
  editCache(data) {
    return request._post('/shop/setting.clear/index', data);
  },
  /*物流公司列表*/
  expressList(data) {
    return request._post('/shop/setting.express/index', data);
  },
  /*添加物流公司*/
  addExpress(data) {
    return request._post('/shop/setting.express/add', data);
  },
  /*物流公司详情*/
  expressDetail(data) {
    return request._get('/shop/setting.express/edit', data);
  },
  expressDownUrl(data) {
    return request._get('/shop/setting.express/expressDownUrl', data);
  },
  /*修改物流公司*/
  editExpress(data) {
    return request._post('/shop/setting.express/edit', data);
  },
  /*删除物流公司*/
  deleteExpress(data) {
    return request._post('/shop/setting.express/delete', data);
  },
  /*退货地址列表*/
  addressList(data) {
    return request._post('/shop/setting.address/index', data);
  },
  /*添加退货地址*/
  addAddress(data) {
    return request._post('/shop/setting.address/add', data);
  },
  /*退货地址详情*/
  addressDetail(data) {
    return request._get('/shop/setting.address/edit', data);
  },
  /*修改退货地址*/
  editAddress(data) {
    return request._post('/shop/setting.address/edit', data);
  },
  /*删除退货地址*/
  deleteAddress(data) {
    return request._post('/shop/setting.address/delete', data);
  },
  /*打印机列表*/
  printerList(data) {
    return request._post('/shop/setting.printer/index', data);
  },
  /*打印机类型*/
  printerType(data) {
    return request._get('/shop/setting.printer/add', data);
  },
  /*添加打印机*/
  addPrinter(data) {
    return request._post('/shop/setting.printer/add', data);
  },
  /*打印机详情*/
  printerDetail(data) {
    return request._get('/shop/setting.printer/edit', data);
  },
  /*修改打印机*/
  editPrinter(data) {
    return request._post('/shop/setting.printer/edit', data);
  },
  /*删除打印机*/
  deletePrinter(data) {
    return request._post('/shop/setting.printer/delete', data);
  },
  /*运费模板列表*/
  deliveryList(data) {
    return request._post('/shop/setting.delivery/index', data);
  },
  /*配送区域*/
  deliveryArea(data) {
    return request._post('/shop/setting.delivery/area', data);
  },
  /*添加运费模板*/
  addDelivery(data) {
    return request._post('/shop/setting.delivery/add', data);
  },
  /*运费模板详情*/
  deliveryDetail(data) {
    return request._get('/shop/setting.delivery/edit', data);
  },
  /*修改运费模板*/
  editDelivery(data) {
    return request._post('/shop/setting.delivery/edit', data);
  },
  /*删除运费模板*/
  deleteDelivery(data) {
    return request._post('/shop/setting.delivery/delete', data);
  },
  /*物流公司编码表*/
  getCompany(data) {
    return request._post('/shop/setting.express/companyList', data);
  },
  /*获取客服设置*/
  getMpService(data) {
    return request._get('/shop/setting.MpService/index', data);
  },
  /*修改客服设置*/
  setMpService(data) {
    return request._post('/shop/setting.MpService/index', data);
  },
  /*获取任务设置*/
  getTask(data) {
    return request._get('/shop/setting.Task/index', data);
  },
  /*修改任务设置*/
  setTask(data) {
    return request._post('/shop/setting.Task/index', data);
  },
  /*支付列表*/
  paymentList(data) {
    return request._post('/shop/setting.payment/index', data);
  },
  /*添加支付*/
  addPayment(data) {
    return request._post('/shop/setting.payment/add', data);
  },
  /*支付详情*/
  paymentDetail(data) {
    return request._get('/shop/setting.payment/edit', data);
  },
  /*修改支付*/
  editPayment(data) {
    return request._post('/shop/setting.payment/edit', data);
  },
  /*删除支付*/
  deletePayment(data) {
    return request._post('/shop/setting.payment/delete', data);
  },
    /*生成代码*/
  genCode(data) {
    return request._post('/shop/setting.way/genCode', data);
  },
}

export default SettingApi;



// WEBPACK FOOTER //
// ./src/api/setting.js